<img class="logo" [src]="logoPath" alt="logo" />

<div class="error-page">
  <div class="icon-container mb-5">
    <div class="outer-circle">
      <div class="inner-circle">
        <i class="uil uil-exclamation-triangle"></i>
      </div>
    </div>
  </div>

  <h3 class="mb-3">{{ data.title }}</h3>

  <p class="body-xl-regular mb-4">{{ data.message }}</p>

  @if (isLoggedIn) {
    <sliqpay-ui-button class="btn" testId="back-to-home-btn" routerLink="/"
      >Go Home</sliqpay-ui-button
    >
  } @else {
    <sliqpay-ui-button class="btn" testId="back-to-login-btn" routerLink="/login"
      >Log In</sliqpay-ui-button
    >
  }
</div>
